import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const AbstractTenant = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 25"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M12.3005 4.6686C11.9685 4.09389 11.6112 3.47703 11.3871 3.08602C11.382 3.07759 11.3736 3.07422 11.3651 3.07422H8.34829H3.52975C2.75615 3.07422 2.04155 3.48714 1.65391 4.15624L0.00390625 7.01299H7.58817L2.14604 16.4394C1.76009 17.1085 1.7584 17.9343 2.14604 18.6034C2.66514 19.5034 3.3848 20.7506 3.79773 21.4619H8.3466C7.84941 20.5989 7.25278 19.5641 6.69829 18.6034C6.31233 17.9343 6.31233 17.1085 6.69829 16.4394L12.3022 6.72984C12.6713 6.09107 12.6713 5.30399 12.3022 4.66523L12.3005 4.6686Z" />
      <path d="M20.8098 21.4651H9.93901C9.93058 21.4651 9.92216 21.4601 9.9171 21.4517C9.4098 20.5719 8.82328 19.5606 8.27384 18.605C7.88789 17.9359 7.88789 17.1101 8.27384 16.441L15.9693 3.11289C15.9795 3.09604 16.0031 3.09435 16.0132 3.11289C16.507 3.96738 17.0952 4.98705 17.6413 5.93592C18.0272 6.60334 18.0255 7.42581 17.6413 8.09491L12.1991 17.5247H19.7362C19.7564 17.5247 19.7699 17.5028 19.7598 17.4859L17.5081 13.5842H22.0418C22.0502 13.5842 22.0587 13.5893 22.0637 13.5977C22.571 14.4758 23.1575 15.4921 23.707 16.446C24.0946 17.1168 24.0929 17.941 23.707 18.6118L22.6823 20.3848C22.2946 21.0539 21.58 21.4668 20.8064 21.4668L20.8098 21.4651Z" />
    </svg>
  );
};

AbstractTenant.displayName = 'AbstractTenant';
